import { render, staticRenderFns } from "./DataTableCostTruck.vue?vue&type=template&id=58e2c3d2"
import script from "./DataTableCostTruck.vue?vue&type=script&lang=js"
export * from "./DataTableCostTruck.vue?vue&type=script&lang=js"
import style0 from "./DataTableCostTruck.vue?vue&type=style&index=0&id=58e2c3d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports